<div class="container text-left">
  <mat-toolbar class="titulo">Ordens Cadastradas</mat-toolbar>
  <div class="container text-left">
    <form [formGroup]="form">
      <div class="row">
        <mat-form-field class="md-button-right col-6">
          <mat-label>Preencher Nº do Processo padrão CNJ</mat-label>
          <input maxlength="25" matInput mask="0000000-00.0000.0.00.0000" placeholder="0000000-00.0000.0.00.0000"
            formControlName="numeroProcesso" [attr.data-cy]="'input-numero-processo'">
          <button matSuffix class="float-left" (click)="buscarPorNroProcesso()" [disabled]="!form.valid"
            mat-raised-button [attr.data-cy]="'button-buscar'"> Buscar </button>
          <button matSuffix class="mx-2" (click)="limparBusca()" [disabled]="numeroProcesso.value === ''"
            mat-stroked-button [attr.data-cy]="'button-limpar'"> Limpar </button>
          <mat-hint align="end">{{numeroProcesso.value.length}} / 20</mat-hint>
          <mat-error *ngIf="numeroProcesso.hasError('required')">
            N&uacute;mero CNJ é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="numeroProcesso.hasError('minlength')">
            N&uacute;mero CNJ deve possuir 20 caracteres. Atual
            {{numeroProcesso.value.length}} / 20.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <div class="mat-elevation-z2">
      <table mat-table [dataSource]="dataSource.data" matSort matSortActive="criadoEm" matSortDirection="desc" matSortStart="desc" (matSortChange)="sortEvent($event)" aria-label="Tabela de Ordens" multiTemplateDataRows>
        <ng-container matColumnDef="numeroProcesso">
          <th mat-header-cell *matHeaderCellDef> Nº Processo </th>
          <td mat-cell *matCellDef="let element"> {{element.numeroProcesso | mask: '0000000-00.0000.0.00.0000'}} </td>
        </ng-container>

        <ng-container matColumnDef="tipoOrdem">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoOrdem" matTooltip="Clique para ordenar" matTooltipPosition="above"> Tipo da ordem </th>
          <td mat-cell *matCellDef="let element"> {{element.tipoOrdem | tipoOrdem }} </td>
        </ng-container>

        <ng-container matColumnDef="nroOrdem">
          <th mat-header-cell *matHeaderCellDef> Nº da ordem </th>
          <td mat-cell *matCellDef="let element"> {{element.numeroOrdem}} </td>
        </ng-container>

        <ng-container matColumnDef="nomeServidor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="cadastrador.nome" matTooltip="Clique para ordenar" matTooltipPosition="above"> Usuário </th>
          <td mat-cell *matCellDef="let element"> {{element.cadastrador.nome | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="dtaAnotacao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="criadoEm" matTooltip="Clique para ordenar" matTooltipPosition="above"> Data de envio </th>
          <td mat-cell *matCellDef="let element"> {{formatData(element.criadoEm)}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="status" matTooltip="Clique para ordenar" matTooltipPosition="above"> Status </th>
          <td mat-cell *matCellDef="let element" [style]="setStyleByStatus(element.status)">
            {{ element.status | statusOrdem }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cartaResposta">
          <th mat-header-cell *matHeaderCellDef> Carta resposta </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.status == 'FINALIZADO'; else noCarta">
              <button matSuffix (click)="getCartaSolicitacao(element)" mat-raised-button [attr.data-cy]="'button-download-carta-' + element.numeroProcesso">
                <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png" alt="Ícone de download">
                Download
              </button>
            </div>
            <ng-template #noCarta>
              <span class="text-muted">
                {{element.status !== 'CANCELADO' ? 'Aguardando carta' : ''}}
              </span>
            </ng-template>

          </td>
        </ng-container>

        <ng-container matColumnDef="detalhes">
          <th mat-header-cell *matHeaderCellDef> Detalhes </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="detalharOrdem(element)" [attr.data-cy]="'button-detalhes-' + element.numeroProcesso">
              <mat-icon>info</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="element-row"></tr>
      </table>
      <mat-paginator *ngIf="page.totalElements && page.totalElements > 0" [length]="page.totalElements"
        [pageSize]="page.size" [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.number" (page)="pageEvent($event)"
        aria-label="Selecione o nº de páginas" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

</div>
